// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_formContainer__DIMQh {
  position: relative;
  display: grid;
  margin: 45px 5% 0 0;
  grid-template-columns: 220px 1fr;
  gap: 30px;
}

.Form_gridContainer__c9Zhw {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.1rem;

  .Form_field__IZIBH {
    width: 100% !important;
    align-content: end;
  }

  input {
    width: 100% !important;
  }
}

/* Smartphone (less than 768px) */
/* Mobile */
@media (max-width: 767px) {
  .Form_gridContainer__c9Zhw {
    grid-template-columns: repeat(1, 1fr);
  }
}

.Form_file_upload__aEy2q {
  .p-button-icon {
    display: none;
  }

  .p-fileupload-choose {
    border-radius: 30px;
    /* min-width: 150px; */
  }
}

.Form_stickyWrapper__Lb9L6 {
  position: sticky;
  display: grid;
  grid-template-rows: 50vh auto;
  top: 15px;
  gap: 30px;
}

.Form_formNavSection__FhwJI {
  background-color: #22272ae0;
  color: white;
  font-size: 0.875em;
  line-height: 1.3;
  border-radius: 5px;
  padding: 30px 10px;
}

.Form_form__Jl6hT {
  padding: 0;
}

.Form_formTitle__8LfIM {
  margin: 0 0 15px 0;
}

.Form_formDesc__aGyFn {
  font-size: medium;
  margin-bottom: 30px;
}

.Form_blockWrapper__rliqV {
  display: flex;
  flex-direction: column;
}

.Form_block__1x4XG {
  position: relative;
  background-color: white;
  padding: 20px 30px;
  border-radius: 5px;
}

.Form_pageSummary__XxfwV {
  font-size: small;
  text-align: center;
  margin-bottom: 30px;
}

.Form_toogleAll__MZtqJ {
  text-align: right;
  margin-bottom: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.8em;
  color: var(--blue);
}

.Form_toogle__0O3ld {
  font-size: 2em;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.Form_fieldsWrapper__7b0W- {
  margin: 15px 0 15px 0;
  display: flex;
  flex-direction: column;
}

.Form_fieldsWrapperCollapse__QNsoY {
  margin: 0;
  height: 0;
}

.Form_blockTitle__svcWN {
  margin: 0;
}

.Form_hidden__zAU4P {
  display: none;
}

.Form_field__IZIBH {
  width: 100%;
  color: black;
  font-size: medium;
}

.Form_field__IZIBH textarea {
  width: 75%;
}

.Form_skeletonTitle__Snnau {
  margin-bottom: 15px;
}

.Form_skeletonLabel__lXe5h {
  margin-bottom: 5px;
}

.Form_label__hkX3a {
  font-size: 14px !important;
  font-weight: bold;
  color: #383838 !important;
  font-size: medium;
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
}

.Form_description__qugLk {
  font-size: 0.875em;
  margin-bottom: 5px;
  font-weight: 300;
  color: var(--branded-font-color);
}

.Form_errFieldMsg__90ioD {
  font-size: small;
  color: var(--branded-error-red);
}

.Form_btnBack__b3mpk {
  display: inline-flex;
  cursor: pointer;
  color: white;
  font-size: 1rem;
  padding: 8px 20px 11px;
  border: none;
  border-radius: 4px;
  background-color: var(--branded-purple);
  margin: 5px;
}

.Form_validFieldMsg__sV6zz {
  font-size: small;
  color: green;
}

.Form_asterisk__d3vcq {
  color: red;
  padding-left: 4px;
}

.Form_button_selector__iLn8j {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.Form_group_container__wpCGL {
  border: 1px solid var(--branded-light-purple);
  border-radius: 12px;
  padding: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: end;
  gap: 1rem;
}

.Form_container__JAQM8 {
  border: 1px solid var(--branded-light-purple);
  border-radius: 12px;
  padding: 1rem;
}

.Form_field_radiobutton__OSDwa {
  margin-bottom: 5px;

  label {
    margin-left: 5px;
    font-size: 0.89rem;
    color: var(--branded-font-color);
  }
}

.Form_form_actions__LuxzX {
  margin-top: 1rem;
  display: flex;
  gap: 20px;
  height: 48px;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
}

/* Restore bullets only for your custom lists */
ul .Form_errorItem__9mPH4 {
  list-style: disc; /* or circle, square */
  margin-left: 1.5rem; /* add indentation */
  padding-left: 0; /* adjust if needed */
}

.Form_errorTooltip__nwyTI .p-tooltip-text {
  max-width: none !important;
}

/* Mobile */
@media (max-width: 767px) {
  .Form_button_selector__iLn8j {
    flex-direction: column;
    align-items: start;
  }

  .Form_group_container__wpCGL {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Form.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;;EAEX;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,iCAAiC;AACjC,WAAW;AACX;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,SAAS;EACT,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;;EAElB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB,EAAE,sBAAsB;EACxC,mBAAmB,EAAE,oBAAoB;EACzC,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".formContainer {\r\n  position: relative;\r\n  display: grid;\r\n  margin: 45px 5% 0 0;\r\n  grid-template-columns: 220px 1fr;\r\n  gap: 30px;\r\n}\r\n\r\n.gridContainer {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 1.1rem;\r\n\r\n  .field {\r\n    width: 100% !important;\r\n    align-content: end;\r\n  }\r\n\r\n  input {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n/* Smartphone (less than 768px) */\r\n/* Mobile */\r\n@media (max-width: 767px) {\r\n  .gridContainer {\r\n    grid-template-columns: repeat(1, 1fr);\r\n  }\r\n}\r\n\r\n.file_upload {\r\n  :global(.p-button-icon) {\r\n    display: none;\r\n  }\r\n\r\n  :global(.p-fileupload-choose) {\r\n    border-radius: 30px;\r\n    /* min-width: 150px; */\r\n  }\r\n}\r\n\r\n.stickyWrapper {\r\n  position: sticky;\r\n  display: grid;\r\n  grid-template-rows: 50vh auto;\r\n  top: 15px;\r\n  gap: 30px;\r\n}\r\n\r\n.formNavSection {\r\n  background-color: #22272ae0;\r\n  color: white;\r\n  font-size: 0.875em;\r\n  line-height: 1.3;\r\n  border-radius: 5px;\r\n  padding: 30px 10px;\r\n}\r\n\r\n.form {\r\n  padding: 0;\r\n}\r\n\r\n.formTitle {\r\n  margin: 0 0 15px 0;\r\n}\r\n\r\n.formDesc {\r\n  font-size: medium;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.blockWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.block {\r\n  position: relative;\r\n  background-color: white;\r\n  padding: 20px 30px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.pageSummary {\r\n  font-size: small;\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.toogleAll {\r\n  text-align: right;\r\n  margin-bottom: 15px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: flex-end;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  font-size: 0.8em;\r\n  color: var(--blue);\r\n}\r\n\r\n.toogle {\r\n  font-size: 2em;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.fieldsWrapper {\r\n  margin: 15px 0 15px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.fieldsWrapperCollapse {\r\n  margin: 0;\r\n  height: 0;\r\n}\r\n\r\n.blockTitle {\r\n  margin: 0;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.field {\r\n  width: 100%;\r\n  color: black;\r\n  font-size: medium;\r\n}\r\n\r\n.field textarea {\r\n  width: 75%;\r\n}\r\n\r\n.skeletonTitle {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.skeletonLabel {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.label {\r\n  font-size: 14px !important;\r\n  font-weight: bold;\r\n  color: #383838 !important;\r\n  font-size: medium;\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 0.3rem;\r\n}\r\n\r\n.description {\r\n  font-size: 0.875em;\r\n  margin-bottom: 5px;\r\n  font-weight: 300;\r\n  color: var(--branded-font-color);\r\n}\r\n\r\n.errFieldMsg {\r\n  font-size: small;\r\n  color: var(--branded-error-red);\r\n}\r\n\r\n.btnBack {\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  color: white;\r\n  font-size: 1rem;\r\n  padding: 8px 20px 11px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background-color: var(--branded-purple);\r\n  margin: 5px;\r\n}\r\n\r\n.validFieldMsg {\r\n  font-size: small;\r\n  color: green;\r\n}\r\n\r\n.asterisk {\r\n  color: red;\r\n  padding-left: 4px;\r\n}\r\n\r\n.button_selector {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.group_container {\r\n  border: 1px solid var(--branded-light-purple);\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  align-items: end;\r\n  gap: 1rem;\r\n}\r\n\r\n.container {\r\n  border: 1px solid var(--branded-light-purple);\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n}\r\n\r\n.field_radiobutton {\r\n  margin-bottom: 5px;\r\n\r\n  label {\r\n    margin-left: 5px;\r\n    font-size: 0.89rem;\r\n    color: var(--branded-font-color);\r\n  }\r\n}\r\n\r\n.form_actions {\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  gap: 20px;\r\n  height: 48px;\r\n  width: 100%;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n}\r\n\r\n/* Restore bullets only for your custom lists */\r\nul .errorItem {\r\n  list-style: disc; /* or circle, square */\r\n  margin-left: 1.5rem; /* add indentation */\r\n  padding-left: 0; /* adjust if needed */\r\n}\r\n\r\n.errorTooltip :global(.p-tooltip-text) {\r\n  max-width: none !important;\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width: 767px) {\r\n  .button_selector {\r\n    flex-direction: column;\r\n    align-items: start;\r\n  }\r\n\r\n  .group_container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `Form_formContainer__DIMQh`,
	"gridContainer": `Form_gridContainer__c9Zhw`,
	"field": `Form_field__IZIBH`,
	"file_upload": `Form_file_upload__aEy2q`,
	"stickyWrapper": `Form_stickyWrapper__Lb9L6`,
	"formNavSection": `Form_formNavSection__FhwJI`,
	"form": `Form_form__Jl6hT`,
	"formTitle": `Form_formTitle__8LfIM`,
	"formDesc": `Form_formDesc__aGyFn`,
	"blockWrapper": `Form_blockWrapper__rliqV`,
	"block": `Form_block__1x4XG`,
	"pageSummary": `Form_pageSummary__XxfwV`,
	"toogleAll": `Form_toogleAll__MZtqJ`,
	"toogle": `Form_toogle__0O3ld`,
	"fieldsWrapper": `Form_fieldsWrapper__7b0W-`,
	"fieldsWrapperCollapse": `Form_fieldsWrapperCollapse__QNsoY`,
	"blockTitle": `Form_blockTitle__svcWN`,
	"hidden": `Form_hidden__zAU4P`,
	"skeletonTitle": `Form_skeletonTitle__Snnau`,
	"skeletonLabel": `Form_skeletonLabel__lXe5h`,
	"label": `Form_label__hkX3a`,
	"description": `Form_description__qugLk`,
	"errFieldMsg": `Form_errFieldMsg__90ioD`,
	"btnBack": `Form_btnBack__b3mpk`,
	"validFieldMsg": `Form_validFieldMsg__sV6zz`,
	"asterisk": `Form_asterisk__d3vcq`,
	"button_selector": `Form_button_selector__iLn8j`,
	"group_container": `Form_group_container__wpCGL`,
	"container": `Form_container__JAQM8`,
	"field_radiobutton": `Form_field_radiobutton__OSDwa`,
	"form_actions": `Form_form_actions__LuxzX`,
	"errorItem": `Form_errorItem__9mPH4`,
	"errorTooltip": `Form_errorTooltip__nwyTI`
};
export default ___CSS_LOADER_EXPORT___;
